import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("锁定项目成本")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("解锁项目成本")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("已锁定")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("未锁定")

import { ref, Ref, reactive, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { formatNumber, getNumber } from '@/utils/index'
import dayjs from 'dayjs'
import tbMix, {cpyCfig} from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/project_cost_details/list': fetchList,
  // 锁定项目成本
  'PATCH/project_cost_time/locked_time': locked_timeApi,
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const searchConfig = ref([
  {
    type: "TIME",
    label: "时间",
    value: [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')],
    upKey: 'dateRange',
    upProps: { startKey: 'from', endKey: 'to', },
    timeCb: (time: string): void => {
      searchHandle({...MI_params, from: time[0], to: time[1]})
    },
    props: { type: 'daterange', clearable: true, },
  },
  {
    type: 'SELECT',
    label: '类型',
    value: 'ALL',
    upKey: 'type',
    options: [
      { label: '单位养老保险', id: 'CompanyEndowment' },
      { label: '单位医疗保险', id: 'CompanyMedical' },
      { label: '单位工伤保险', id: 'CompanyInjury' },
      { label: '单位生育保险', id: 'CompanyMaternity' },
      { label: '单位失业保险', id: 'CompanyUnemployment' },
      { label: '单位公积金', id: 'CompanyHousing' },
      { label: '五险一金', id: 'FiveInsurancesFund' },
      { label: '项目成本', id: 'ProjectCost' },
      { label: '全部', id: 'ALL' },
    ],
    selectCb: (type: string): void => {
      searchHandle({...MI_params, type})
    },
    props: { clearable: false, placeholder: '请选择类型', filterable: false },
    seleProps: { label: 'label', valueName: 'id', }
  },
  cpyCfig({
    selectCb: (companyId: string): void => {
      searchHandle({...MI_params, companyId})
    },
  })
])
let dynamicTotal: any = ref([])
let lockStatue = ref<boolean>(false)
const searchHandle = async (params: any) => {
  let { total, flag } = await fetchData({
    ...params,
    dateRange: {
      from: params.from,
      to: params.to,
    }
  })
  lockStatue.value = flag === '未锁定' ? false : true
  dynamicTotal.value = total
}

const calculDate = computed(() => {
  return MI_tableData.value.map(e => {
    // e.ALL = e.personalTotalAmount
    e.projectList.push({data: e.personalTotalAmount, projectName: 'ALL', purpose: 'ALL'})
    return e
  })
})

// 添加
const addConfig = ref([])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async (params: any) => {
    ElMessage.success('成功')
    addFg.value = false
    searchHandle(MI_params)
  })
}

// 锁定项目成本
const lockedFg = ref(false)
const lockedConfig = ref([
  {
    type: "TIME",
    label: "锁定日期",
    value: '',
    upKey: 'dates',
    upProps: { includeKey: 'dateRange' },
    rule: [{ required: true, message: '请选择锁定日期', trigger: 'change' }],
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD',
      clearable: true
    }
  },
])
const lockHandle = () => {
  MI_modifyForm({}, lockedConfig, lockedFg, async (params: any) => {
    await locked_timeApi({...params, flag: true})
    ElMessage.success('锁定成功')
    lockedFg.value = false
    searchHandle(MI_params)
  })
}
// 解锁项目成本
const unlockedFg = ref(false)
const unlockHandle = () => {
  MI_modifyForm({}, lockedConfig, unlockedFg, async (params: any) => {
    await locked_timeApi({...params, flag: false})
    ElMessage.success('解锁成功')
    unlockedFg.value = false
    searchHandle(MI_params)
  })
}

// ---------------
const formatProjectList = (row: any, projcet: any) => {
  let obj = row.projectList.find((e: any) => e.purpose === projcet.purpose) || { data: 0 }
  return getNumber(obj.data)
}
const getSummaries = (param: any) => {
  const { columns, data } = param
  const sums: string[] = []
  columns.forEach((column: any, index: any) => {
    if (index === 0) {
      sums[0] = '合计'
      return
    }
    // const values = data.map((item: any) => Number(item[column.property]))
    // sums[index] = getNumber(summaryVo['sum' + column.property.charAt(0).toUpperCase() + column.property.slice(1)])
    let obj = dynamicTotal.value.find((project: any) => project.purpose === column.property)
    sums[index] = obj ? getNumber(obj.total) : '-'
  })

  return sums
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: searchHandle }), {
      btnGroup: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (lockHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })), [
          [_directive_permission, 'Write']
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (unlockHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })), [
          [_directive_permission, 'Write']
        ]),
        (_unref(lockStatue))
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              class: "ml-10"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(lockStatue))
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              class: "ml-10",
              type: "danger"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      "show-summary": "",
      "summary-method": getSummaries,
      ref: "tb",
      border: "",
      data: _unref(calculDate),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.realName + ' (' + row.alias + ')'), 1)
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dynamicTotal), (project) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "right",
            key: project.purpose,
            label: project.projectName,
            formatter: (row) => formatProjectList(row, project),
            prop: project.purpose,
            "show-overflow-tooltip": ""
          }, null, 8, ["label", "formatter", "prop"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange),
      disabled: _unref(MI_identify)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange", "disabled"]),
    _createVNode(_component_el_dialog, {
      title: "锁定项目成本",
      modelValue: lockedFg.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((lockedFg).value = $event)),
      draggable: ""
    }, {
      default: _withCtx(() => [
        (lockedFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: lockedConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "解锁项目成本",
      modelValue: unlockedFg.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((unlockedFg).value = $event)),
      draggable: ""
    }, {
      default: _withCtx(() => [
        (unlockedFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: lockedConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})